export class FocusTrap {
  #handler = this.#handleKeydown.bind(this);
  #lastFocusedElement;
  #focusableElements;

  constructor(element) {
    this.#focusableElements = this.#getFocusableElements(element);
  }

  #getFocusableElements(container) {
    return [...container.querySelectorAll(
      'a, button, input:not([type="hidden"]), textarea, select, details, iframe, embed, object, summary, dialog, audio[controls], video[controls], [contenteditable], [tabindex]'
    )].filter(element => {
      if (window.getComputedStyle(element).display === 'none') return false;
      if (element.hasAttribute('disabled')) return false;
      if (element.hasAttribute('hidden')) return false;

      return true;
    });
  }

  #handleKeydown(e) {
    if (e.key !== 'Tab') {
      return;
    }

    if (e.shiftKey && document.activeElement === this.#firstFocusableElement) {
      this.#lastFocusableElement.focus();
      e.preventDefault();
    } else if (!e.shiftKey && document.activeElement === this.#lastFocusableElement) {
      this.#firstFocusableElement.focus();
      e.preventDefault();
    }
  }

  get #firstFocusableElement() {
    return this.#focusableElements[0];
  }

  get #lastFocusableElement() {
    return this.#focusableElements[this.#focusableElements.length - 1];
  }

  enable() {
    document.addEventListener('keydown', this.#handler);
  }

  disable() {
    document.removeEventListener('keydown', this.#handler);
  }

  prepend(...elements) {
    this.#focusableElements = [...elements, ...this.#focusableElements];
  }

  append(...elements) {
    this.#focusableElements = [...this.#focusableElements, ...elements];
  }
}